import React from 'react';
import { useTranslation } from 'react-i18next';

const BloodGroup = ({ value, onChange, error }) => {
  const { t } = useTranslation();
  
  const handleGroupChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className='formFieldContainer'>
    <label className='formLabel'>
      {t('form.bloodGroup')}
      <select className='textField-select'
        name="bloodGroup"
        value={value}
        onChange={handleGroupChange}>
        <option value="">{t('form.select')}</option>
        <option value="O+">O+</option>
        <option value="O-">O-</option>
        <option value="A+">A+</option>
        <option value="A-">A-</option>
        <option value="B+">B+</option>
        <option value="B-">B-</option>
        <option value="AB+">AB+</option>
        <option value="AB-">AB-</option>
      </select>
    {error && <span className="errorMessage">{error}</span>}
    </label>
    </div>
  );
};

export default BloodGroup;
